import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "circuit-card card" }

import {onMounted, ref} from "vue";
	import FetchOptions from "../interfaces/FetchOptions";
	import {FetchData} from "../utils/FetchData";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'CircuitCard',
  props: {
    circuit: {}
  },
  emits: [
		'deleteCircuit'
	],
  setup(__props: any, { emit: __emit }) {

	const circuit = ref({});

	const props = __props;

	const emit = __emit;

	onMounted(() => {
		circuit.value = JSON.parse(JSON.stringify(props.circuit));
	});

	async function saveCircuit() {
		const body = circuit.value;
		delete body.races;

		if(body.id !== undefined) {
			const options: FetchOptions = {
				method: 'PATCH',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('circuits/' + circuit.value.id, options);
			if(!data.isError)
				emitter.emit('showMessage', {message: 'Circuit opgeslagen', header: 'Gelukt'});
		}
		else {
			const options: FetchOptions = {
				method: 'POST',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('circuits', options);
			if(!data.isError) {
				circuit.value = data.data;
				emitter.emit('showMessage', {message: 'Circuit toegevoegd', header: 'Gelukt'});
			}
		}
	}

	function deleteCircuit() {
		emit('deleteCircuit', circuit.value);
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((circuit.value.country) = $event))
    }, null, 512), [
      [_vModelText, circuit.value.country]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((circuit.value.circuit) = $event))
    }, null, 512), [
      [_vModelText, circuit.value.circuit]
    ]),
    _createElementVNode("button", {
      class: "content-box",
      onClick: deleteCircuit
    }, " Verwijderen "),
    _createElementVNode("button", {
      class: "content-box",
      onClick: saveCircuit
    }, " Opslaan ")
  ]))
}
}

})